import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RT_API} from '../../../core/services/app.interceptor';
import {Base64Decode} from '../../../core/utils/base64-decode';


@Injectable({
  providedIn: 'root'
})

export class AuthService {

  constructor(private httpClient: HttpClient) {
  }


  getCurrentUser(user_type: string) {
    return this.getUserById(0);
  }

  loginByAuthCode(auth_code: string) {
    return this.httpClient.get(`${RT_API}/api/lumii/getuserbycode?code=${auth_code}`);
  }

  getUserById(id: number) {
    return this.httpClient.get(`{rt-api}/api/lumii/userdetails?userId=${id}`);
  }

  changeForgottenPassword(code: number, password: string) {
    const decodePassword = Base64Decode.base64EncArr(Base64Decode.strToUTF8Arr(password));
    const body = {
      code,
      password: decodePassword
    };
    return this.httpClient.post(`api/change_forgotten_password`, body);
  }

  login(userName: string, password: string) {
    const decodeUsername = Base64Decode.base64EncArr(
      Base64Decode.strToUTF8Arr(userName)
    );
    const decodePassword = Base64Decode.base64EncArr(
      Base64Decode.strToUTF8Arr(password)
    );
    const body = new FormData();
    body.append('username', decodeUsername);
    body.append('password', decodePassword);
    return this.httpClient.post(`{rt-api}/api/lumii/token`, body);
  }

  loginBySmsCode(phone: string, code: string) {
    // const decodeUsername = Base64Decode.base64EncArr(
    //   Base64Decode.strToUTF8Arr(phone)
    // );
    // const decodePassword = Base64Decode.base64EncArr(
    //   Base64Decode.strToUTF8Arr(code)
    // );
    const body = new FormData();
    body.append('phone', phone);
    body.append('code', code);
    return this.httpClient.post(`api/client/token`, body);
  }

  loginUserBySmsCode(phone: string, code: string) {
    // const decodeUsername = Base64Decode.base64EncArr(
    //   Base64Decode.strToUTF8Arr(phone)
    // );
    // const decodePassword = Base64Decode.base64EncArr(
    //   Base64Decode.strToUTF8Arr(code)
    // );
    const body = new FormData();
    body.append('phone', phone);
    body.append('code', code);
    return this.httpClient.post(`api/user/sms/token`, body);
  }
}
